import './style/Consultants.css';
import {Container, Row, Col} from 'react-bootstrap';
import ConsultantFilter from './components/ConsultantFilter';
import ConsultantsList from './components/ConsultantsList';
import {Fragment, useEffect, useState} from 'react';
import logo from './style/header.png';
import {getConsultantsList} from './Consultants.service';
import {useParams,useNavigate,useLocation} from 'react-router-dom';
import { isUserLoggedIn } from '../../auth/utiles';
import { useTranslation} from 'react-i18next';
import { NavLink } from 'react-router-dom';
import SearchInput from '../../components/search-input/SearchInput';
import HomeConsultantsList from './components/HomeConsultantsList';

const HomeTeachers = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  let type = 'teachers';
  const location = useLocation();
  const [page, setPage] = useState<number>(1);
  const [name, setName] = useState<string>('');
  const [languagesSelected, setLanguagesSelected] = useState<number[]>([]);
  const [fieldsSelected, setFieldsSelected] = useState<{[key: string]: any[]}>(
    {},
  );
  const [selectedDays, setSelectedDays] = useState<any[] | null>([]);
  const [selectedTime, setSelectedTime] = useState<number | null>();
  const [typesSelected, setTypesSelected] = useState<string[]>([]);

  useEffect(() => {
    const Logged = isUserLoggedIn();
    //if( Logged ){
      getConsultants();
    //}else{
      //navigate(`/login`, {state: {location: location.pathname }})
    //}
  }, [
    page,
    name,
    type,
    languagesSelected,
    fieldsSelected,
    selectedTime,
    selectedDays,
    typesSelected,
  ]);

  const getConsultants = () => {
    getConsultantsList({
      page: page,
      load: false,
      /*
      type:
        typesSelected.length != 0
          ? typesSelected
          : ['consultant', 'organization' , 'teacher' ]
          ? ['consultant', 'organization' , 'teacher' ]
          : ['consultant', 'organization' , 'teacher' ],
      */ 
      type:['teacher'],  
      name: name,
      language: languagesSelected,
      fields: fieldsSelected,
      selectedDays: selectedDays,
      selectedTime: selectedTime,
      is_top: 1,
    });
  };

  const handleSearch = (searchTerm: any) => {
    setPage(1);
    setName(searchTerm)
  };

  return (
    <Fragment>
      
      <div className="content-details mb-5">
          <Container>
            
            {/*
            <Row className="justify-content-between top-list-filters align-items-center">
              <Col md="8">
              <ConsultantFilter
              type={type}
              setLang={setLanguagesSelected}
              setField={setFieldsSelected}
              setDays={setSelectedDays}
              setTimes={setSelectedTime}
              setTypes={setTypesSelected}
            />
              </Col>

              <Col md="4">
                <div className="row courses-top-head justify-content-between align-items-center">
                  <SearchInput onSearch={handleSearch} />
                </div>
              </Col>
            </Row>
            */}

            <Row className="d-flex justify-content-between list-filter align-items-center">

            <Col
              lg="12"
              className="mentors d-flex justify-content-between align-items-center px-md-3">
                <h1
                  className="m-0 text-center"
                  style={{fontWeight: '700', color: '#1E1E1E',fontSize:'23px'}}>
                  {t('Teacher')}
                </h1>
                <NavLink
                  to={'/consultants/get-teachers'}
                  className={'see-more'}>
                  {t('See More')} <img src="/arrow-angle.png" alt="image" />
                </NavLink>
              </Col>

              <Col md={12}>
                <HomeConsultantsList
                  setPaginate={false}
                  setPage={page => setPage(page)}
                  page={page}
                  submitTitle={name => {
                    setName(name);
                  }}
                />
              </Col>
            </Row>
          </Container>
        </div>
    </Fragment>
  );
};

export default HomeTeachers;
